import { render } from "./AdditionalInsurances.vue?vue&type=template&id=53f3a885&scoped=true"
import script from "./AdditionalInsurances.vue?vue&type=script&lang=js"
export * from "./AdditionalInsurances.vue?vue&type=script&lang=js"

import "./AdditionalInsurances.vue?vue&type=style&index=0&id=53f3a885&scoped=true&lang=css"

import exportComponent from "/Users/robertprikryl/smartAIm/unity_media/vue-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53f3a885"]])

export default __exports__